export default __webpack_public_path__ + "5b2a67569afbf010e4fdabea4dad516b.svg";